export const combineUrls = (...args: string[]) =>
  args
    .map(str => str.replace(/^\//, ''))
    .join('/')
    .replace(/\/$/, '');
